module.exports = __webpack_public_path__ + "img/left.e1ca860a.png";